
import React, { useEffect, useRef, useState } from "react";
import ayurveda1 from "../Patient/components/image/ayurveda1.png";
import ayurveda2 from "../Patient/components/image/ayurveda2.png";

const AyurvedaWellness = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(() => (typeof window !== "undefined" ? window.innerWidth <= 768 : false));
  const autoTimer = useRef(null);
  const totalSlides = 3;

  const goTo = (n) => {
    setCurrentSlide((n + totalSlides) % totalSlides);
  };

  const startAuto = () => {
    clearInterval(autoTimer.current);
    autoTimer.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 2000);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    startAuto();
    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(autoTimer.current);
    };
  }, []);

  const handlePrev = () => { clearInterval(autoTimer.current); goTo(currentSlide - 1); startAuto(); };
  const handleNext = () => { clearInterval(autoTimer.current); goTo(currentSlide + 1); startAuto(); };
  const handleDot  = (i) => { clearInterval(autoTimer.current); goTo(i); startAuto(); };

  const styles = {
    page: {
      fontFamily: "'Georgia', 'Times New Roman', serif",
      backgroundColor: "#fdf6ec",
      color: "#2c1a0e",
      overflowX: "hidden",
    },

    /* ── HERO SLIDER WRAPPER ── */
    heroSlider: {
      background: "linear-gradient(135deg, #0f2a44 0%, #1f7a8c 40%, #2ec4b6 100%)",
      position: "relative",
      overflow: "hidden",
    },
    sliderTrack: {
      display: "flex",
      transform: `translateX(-${currentSlide * 100}%)`,
      transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
      alignItems: "flex-start",
    },

    /* ── SLIDE 1: TEXT ── */
    slideText: {
      minWidth: "100%",
      color: "#fff",
      textAlign: "center",
      padding: isMobile ? "56px 16px 42px" : "80px 20px 60px",
      boxSizing: "border-box",
    },
    heroBadge: {
      display: "inline-block",
      background: "rgba(255,215,0,0.2)",
      border: "1px solid rgba(255,215,0,0.6)",
      color: "#ffd700",
      fontSize: "12px",
      letterSpacing: "3px",
      textTransform: "uppercase",
      padding: "6px 18px",
      borderRadius: "20px",
      marginBottom: "20px",
    },
    heroTitle: {
      fontSize: "clamp(2rem, 5vw, 3.8rem)",
      fontWeight: "700",
      lineHeight: "1.2",
      marginBottom: "16px",
      textShadow: "0 2px 10px rgba(0,0,0,0.3)",
    },
    heroDivider: {
      width: "80px",
      height: "3px",
      background: "linear-gradient(90deg, transparent, #ffd700, transparent)",
      margin: "0 auto 20px",
      border: "none",
    },
    heroSubtitle: {
      fontSize: "clamp(1rem, 2.5vw, 1.3rem)",
      fontStyle: "italic",
      color: "#c8e6b0",
      margin: "0 auto 16px",
      maxWidth: "600px",
    },
    heroDesc: {
      maxWidth: "650px",
      margin: "0 auto 40px",
      fontSize: "1rem",
      lineHeight: "1.8",
      color: "#d4edda",
    },
    heroCallout: {
      display: "inline-block",
      background: "rgba(255,215,0,0.15)",
      border: "1px solid rgba(255,215,0,0.5)",
      color: "#ffd700",
      padding: "12px 30px",
      borderRadius: "50px",
      fontSize: "1rem",
      fontWeight: "700",
      letterSpacing: "0.5px",
    },

    /* ── SLIDE 2: IMAGE — centered with margin ── */
slideImage: {
  minWidth: "100%",
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: isMobile ? "24px 5%" : "40px 12.5%",
},
slideImg: {
  width: isMobile ? "92%" : "60%",
  maxWidth: "860px",
  display: "block",
  height: "auto",
  objectFit: "contain",
  borderRadius: "12px",
  boxShadow: "0 8px 40px rgba(0,0,0,0.4)",
},

    /* ── ARROWS ── */
    sliderBtn: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: isMobile ? "40px" : "44px",
      height: isMobile ? "40px" : "44px",
      borderRadius: "50%",
      background: "rgba(255,215,0,0.2)",
      border: "2px solid rgba(255,215,0,0.7)",
      color: "#ffd700",
      fontSize: "24px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
      lineHeight: "1",
    },
    sliderPrev: { left: "16px" },
    sliderNext: { right: "16px" },

    /* ── DOTS + CAPTION BAR ── */
    bottomBar: {
      background: "rgba(0,0,0,0.25)",
      padding: isMobile ? "12px 14px" : "14px 20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
    },
    dotsContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
    },
    dot: (active) => ({
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      border: "2px solid rgba(255,215,0,0.8)",
      background: active ? "#ffd700" : "transparent",
      cursor: "pointer",
      transition: "background 0.3s ease",
    }),
    caption: {
      textAlign: "center",
      fontSize: isMobile ? "0.8rem" : "0.88rem",
      color: "#c8e6c8",
      fontStyle: "italic",
      margin: 0,
      lineHeight: 1.5,
    },

    /* ── FEATURES ── */
    featuresSection: { padding: "60px 20px", backgroundColor: "#fff" },
    sectionTitle: {
      textAlign: "center",
      fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
      color: "#0f2a44",
      marginBottom: "10px",
      fontWeight: "700",
    },
    sectionUnderline: {
      width: "60px",
      height: "3px",
      background: "linear-gradient(135deg, #0f2a44 0%, #1f7a8c 40%, #2ec4b6 100%)",
      margin: "0 auto 40px",
      border: "none",
      borderRadius: "2px",
    },
    featuresGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "24px",
      maxWidth: "1100px",
      margin: "0 auto",
    },
    featureCard: {
      background: "linear-gradient(145deg, #f0faf0, #fdf6ec)",
      border: "1px solid #d4edda",
      borderRadius: "16px",
      padding: isMobile ? "22px 18px" : "30px 24px",
      textAlign: "center",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "default",
    },
    featureIcon: { fontSize: "2.5rem", marginBottom: "14px" },
    featureTitle: {
      fontSize: "1rem", fontWeight: "700", color: "#0f2a44",
      marginBottom: "8px", textTransform: "uppercase", letterSpacing: "1px",
    },
    featureDesc: { fontSize: "0.88rem", color: "#5a4a3a", lineHeight: "1.6" },

    /* ── WELLNESS PROGRAMS ── */
    programsSection: { padding: "60px 20px", backgroundColor: "#fff" },
    programsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: "20px",
      maxWidth: "1100px",
      margin: "0 auto",
    },
    programCard: {
      background: "#fff",
      border: "1px solid #e0f0e0",
      borderLeft: "5px solid #0f2a44",
      borderRadius: "12px",
      padding: isMobile ? "18px 16px" : "24px 20px",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    },
    programEmoji: { fontSize: "2rem", marginBottom: "10px" },
    programName: { fontSize: "1.05rem", fontWeight: "700", color: "#0f2a44", marginBottom: "6px" },
    programDesc: { fontSize: "0.87rem", color: "#5a4a3a", lineHeight: "1.65" },

    /* ── PACKAGES ── */
    packagesSection: {
      padding: "60px 20px",
      background: "linear-gradient(135deg, #0f2a44 0%, #1f7a8c 40%, #2ec4b6 100%)",
      color: "#fff",
    },
    packagesTitleWhite: {
      textAlign: "center", fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
      color: "#ffd700", marginBottom: "10px", fontWeight: "700",
    },
    packagesUnderline: {
      width: "60px", height: "3px",
      background: "linear-gradient(90deg, transparent, #ffd700, transparent)",
      margin: "0 auto 40px", border: "none",
    },
    packagesGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "20px",
      maxWidth: "1000px",
      margin: "0 auto",
    },
    packageCard: {
      background: "rgba(255,255,255,0.08)",
      border: "1px solid rgba(255,215,0,0.3)",
      borderRadius: "16px",
      padding: isMobile ? "22px 16px" : "28px 20px",
      textAlign: "center",
    },
    packageDays: { fontSize: "2.5rem", fontWeight: "900", color: "#ffd700", lineHeight: "1" },
    packageDaysLabel: { fontSize: "0.75rem", letterSpacing: "2px", textTransform: "uppercase", color: "#c8e6b0", marginBottom: "12px" },
    packageName: { fontSize: "0.9rem", fontWeight: "700", color: "#fff", marginBottom: "10px", textTransform: "uppercase", letterSpacing: "1px" },
    packagePrice: { fontSize: "1.3rem", fontWeight: "800", color: "#ffd700", marginBottom: "4px" },
    packagePriceLabel: { fontSize: "0.75rem", color: "#a8c8a0" },

    /* ── CTA ── */
    ctaSection: { padding: "70px 20px", textAlign: "center", backgroundColor: "#fdf6ec" },
    ctaTitle: { fontSize: "clamp(1.6rem, 3.5vw, 2.4rem)", fontWeight: "700", color: "#6b6bd0", marginBottom: "14px" },
    ctaSubtitle: { fontSize: "1rem", color: "#5a7a5a", marginBottom: "30px", maxWidth: "500px", margin: "0 auto 30px" },
    ctaButtons: { display: "flex", justifyContent: "center", gap: "16px", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row" },
    btnPrimary: {
      background: "linear-gradient(135deg, #0f2a44 0%, #1f7a8c 40%, #2ec4b6 100%)",
      color: "#fff", border: "none", padding: "14px 36px",
      borderRadius: "50px", fontSize: "1rem", fontWeight: "700",
      cursor: "pointer", letterSpacing: "0.5px",
      boxShadow: "0 6px 20px rgba(45,110,45,0.35)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      width: isMobile ? "100%" : "auto",
      minHeight: "48px",
      touchAction: "manipulation",
    },
    btnSecondary: {
      background: "transparent", color: "#2d6e2d",
      border: "2px solid #2d6e2d", padding: "14px 36px",
      borderRadius: "50px", fontSize: "1rem", fontWeight: "700",
      cursor: "pointer", letterSpacing: "0.5px",
      transition: "background 0.2s ease, color 0.2s ease",
      width: isMobile ? "100%" : "auto",
      minHeight: "48px",
      touchAction: "manipulation",
    },

    /* ── FOOTER ── */
    footerStrip: {
      background: "#1a4a1a", color: "#c8e6b0",
      textAlign: "center", padding: "20px",
      fontSize: "0.85rem", letterSpacing: "0.5px",
    },
  };

  const features = [
    { icon: "🌿", title: "Authentic Ayurveda",     desc: "100% natural & safe treatments rooted in ancient wisdom" },
    { icon: "👨‍⚕️", title: "Experienced Doctors",  desc: "Personalized care by certified Ayurvedic practitioners" },
    { icon: "🧘", title: "Holistic Healing",        desc: "Mind, body & soul wellness for complete rejuvenation" },
    { icon: "🥗", title: "Pure Veg Ayurvedic Food", desc: "Healthy & delicious Satvik diet meals included" },
  ];

  const programs = [
    { emoji: "🫁",  name: "Panchakarma Detox",           desc: "Deep cleansing therapy to eliminate toxins and restore balance in the body." },
    { emoji: "💪",  name: "Immunity Boosting",            desc: "Strengthen your natural defenses with herbal therapies and lifestyle practices." },
    { emoji: "🌸",  name: "Stress Relief Therapy",        desc: "Calm your nervous system with Shirodhara, Abhyanga, and mindfulness sessions." },
    { emoji: "🕰️", name: "Anti-Aging Treatments",        desc: "Rejuvenate skin and vitality with time-tested Rasayana therapies." },
    { emoji: "⚖️",  name: "Weight Loss Program",          desc: "Medically supervised Ayurvedic weight management with diet and yoga." },
    { emoji: "🧘‍♀️", name: "Yoga & Meditation Sessions", desc: "Daily guided yoga and meditation for inner peace and flexibility." },
  ];

  const packages = [
    { days: "5",  name: "Wellness Package",     price: "₹35,000" },
    { days: "7",  name: "Rejuvenation Package", price: "₹55,000" },
    { days: "14", name: "Panchakarma Package",  price: "₹1,10,000" },
    { days: "21", name: "Deep Healing Package", price: "₹1,80,000" },
  ];

  return (
    <div style={styles.page}>

      {/* ══════════════════════════════
           HERO SLIDER
         ══════════════════════════════ */}
      <div style={styles.heroSlider}>

        <div style={styles.sliderTrack}>

          {/* ── SLIDE 1: MESSAGE ── */}
          <div style={styles.slideText}>
            <div style={styles.heroBadge}>🌿 In God's Own Country</div>
            <h1 style={styles.heroTitle}>
              Ayurveda &<br />Wellness Holidays
            </h1>
            <hr style={styles.heroDivider} />
            <p style={styles.heroSubtitle}>Rejuvenate Your Mind, Body &amp; Soul</p>
            <p style={styles.heroDesc}>
              Experience the healing touch of authentic Ayurveda, Yoga &amp; Nature
              in the serene land of India.
            </p>
            <div style={styles.heroCallout}>
              📞 Call / WhatsApp: 9922514719
            </div>
          </div>

          {/* ── SLIDE 2: FULL IMAGE — centered with margin ── */}
          <div style={styles.slideImage}>
            <img
              src={ayurveda1}
              alt="Kerala Ayurveda & Wellness Holidays – Full Brochure"
              style={styles.slideImg}
            />
          </div>

          {/* ── SLIDE 3: SECOND IMAGE ── */}
<div style={styles.slideImage}>
  <img
    src={ayurveda2}
    alt="Rishikesh Ayurveda & Wellness – Package Details"
    style={styles.slideImg}
  />
</div>

        </div>

        {/* Arrows */}
        <button type="button" aria-label="Previous slide" onClick={handlePrev} style={{ ...styles.sliderBtn, ...styles.sliderPrev }}>&#8249;</button>
        <button type="button" aria-label="Next slide" onClick={handleNext} style={{ ...styles.sliderBtn, ...styles.sliderNext }}>&#8250;</button>

        {/* Dots + Caption */}
        <div style={styles.bottomBar}>
          <div style={styles.dotsContainer}>
            {[0, 1,2].map((i) => (
              <div key={i} onClick={() => handleDot(i)} style={styles.dot(i === currentSlide)} />
            ))}
          </div>
          <p style={styles.caption}>
            📞 Call / WhatsApp:{" "}
            <strong style={{ color: "#ffd700" }}>9922514719</strong>
            &nbsp;|&nbsp; Book Your Wellness Journey Now!
          </p>
        </div>

      </div>

      {/* ── FEATURES ── */}
      <section style={styles.featuresSection}>
        
        <hr style={styles.sectionUnderline} />
        <div style={styles.featuresGrid}>
          {features.map((f, i) => (
            <div
              key={i} style={styles.featureCard}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 12px 30px rgba(45,110,45,0.15)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
            >
              <div style={styles.featureIcon}>{f.icon}</div>
              <div style={styles.featureTitle}>{f.title}</div>
              <div style={styles.featureDesc}>{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── WELLNESS PROGRAMS ── */}
      <section style={styles.programsSection}>
        <h2 style={styles.sectionTitle}>Wellness Programs</h2>
        <hr style={styles.sectionUnderline} />
        <div style={styles.programsGrid}>
          {programs.map((p, i) => (
            <div
              key={i} style={styles.programCard}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 10px 24px rgba(45,110,45,0.12)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
            >
              <div style={styles.programEmoji}>{p.emoji}</div>
              <div style={styles.programName}>{p.name}</div>
              <div style={styles.programDesc}>{p.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── PACKAGES ── */}
      <section style={styles.packagesSection}>
        <h2 style={styles.packagesTitleWhite}>Ayurveda Packages</h2>
        <p style={{ textAlign: "center", color: "#c8e6b0", marginBottom: "10px", fontSize: "0.9rem" }}>
          Per Person — All Inclusive
        </p>
        <hr style={styles.packagesUnderline} />
        <div style={styles.packagesGrid}>
          {packages.map((pkg, i) => (
            <div key={i} style={styles.packageCard}>
              <div style={styles.packageDays}>{pkg.days}</div>
              <div style={styles.packageDaysLabel}>Days / Nights</div>
              <div style={styles.packageName}>{pkg.name}</div>
              <div style={styles.packagePrice}>{pkg.price}</div>
              <div style={styles.packagePriceLabel}>onwards</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={styles.ctaSection}>
        <h2 style={styles.ctaTitle}>Book Your Wellness Journey</h2>
        <p style={styles.ctaSubtitle}>
          Limited slots available. Customized packages on request.
          Experience true Ayurveda.
        </p>
        <div style={styles.ctaButtons}>
          <button
            style={styles.btnPrimary}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 10px 28px rgba(45,110,45,0.45)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(45,110,45,0.35)"; }}
          >
            📞 Call / WhatsApp: 9922514719
          </button>
          <button
            style={styles.btnSecondary}
            onMouseEnter={e => { e.currentTarget.style.background = "#2d6e2d"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#2d6e2d"; }}
          >
            🌿 View All Packages
          </button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <div style={styles.footerStrip}>
        🌿 Holistic Healing &nbsp;|&nbsp; Natural Living &nbsp;|&nbsp; Healthy Life
      </div>

    </div>
  );
};

export default AyurvedaWellness;